import { Displaying } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";

export const DefaultLayoutContainer = styled(Box)(() => ({
  display: Displaying.flex,
  height: "100%",
}));
